import { Component, OnInit } from "@angular/core";
import { GoogleAnalyticsService } from "ngx-google-analytics";
import { CategoryChoice, ImageInfo, ServiceTask } from "src/app/model/model";
import { ServiceTaskService } from "src/app/services/service-task.service";

@Component({
  selector: "app-landing",
  templateUrl: "./landing.component.html",
  styleUrls: ["./landing.component.css"]
})
export class LandingComponent implements OnInit {

  code = `curl
-X POST http://compai-admin-backend.onrender.com/api/model/opus-mt-es-en
-d '{
  "inputs": {
    "text": "En el mundo de los servicios resulta necesario que el cliente se sienta que es importante y se le escucha. \nCada cual tiene sus fortalezas."
  },
  "token": "<TOKEN>"
}'

// Respuesta de ejemplo
{
  "outputs": {
    "result": [
      {
        "translation_text": "In the world of services it is necessary for the customer to feel that it is important and to be heard. \nEveryone has their strengths."
      }
    ]
  }
}`

  serviceTasksForTexts: ServiceTask[];
  serviceTasksForImages: ServiceTask[];
  imageList: ImageInfo[] = [];

  constructor(private serviceTaskService: ServiceTaskService, protected $gaService: GoogleAnalyticsService) {
    const allServices = this.serviceTaskService.getAll();

    this.serviceTasksForTexts = allServices.filter(x => x.category === CategoryChoice.TEXT);
    this.serviceTasksForImages = allServices.filter(x => x.category === CategoryChoice.IMAGE);
  }

  ngOnInit(): void {
    this.$gaService.pageView("/", "Visit the landing page");

    this.imageList.push(
      new ImageInfo("Conjunto de entidades detectadas en el artículo.",
        'assets/img/app-news-part-entities.webp'),
      new ImageInfo("Grafo con la relación entre las entidades.",
        'assets/img/app-news-part-graph-entities.webp'),
      new ImageInfo("Grafo con la relación entre los tópicos coloreado a partir del análisis de sentimiento.",
        'assets/img/app-news-part-graph-topics.png'),
      new ImageInfo("Análisis de sentimientos sobre los párrafos del artículo o comentarios.",
        'assets/img/app-news-part-sentiment.png'))
  }
}
